module.exports = __webpack_public_path__ + "static/8-929fdda5d9825ce292d5fbac61f5564c.png";